/**
 * default values in the filter on the explore page
 */
export const FilterDefaults = {
  friendsOnly: false,
};
